import React from 'react';

const AIVoiceIcon = ({ className = '', ...props }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none"
      className={`text-white  ${className}`}
      {...props}
    >
      <path 
        d="M12 4V20M16 7V17M8 7V17M20 11V13M4 11V13" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round"
      />
    </svg>
  );
};

export default AIVoiceIcon;
